// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getExperiences as listExperiencesAPI,
    getExperience as getExperienceAPI,
    addExperience as addExperienceAPI,
    updateExperience as updateExperienceAPI,
    deleteExperience as deleteExperienceAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { experiencesApiResponseError, experiencesApiResponseSuccess } from './actions';
import { ExperiencesActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getExperience({ payload: { id } }) {
    try {
        const response = yield call(getExperienceAPI, id );
        const experienceItem = response.data.data;
        yield put(experiencesApiResponseSuccess(ExperiencesActionTypes.GET_EXPERIENCE, experienceItem));
    } catch (error) {
        yield put(experiencesApiResponseError(ExperiencesActionTypes.GET_EXPERIENCE, error));
    }
}

function* addExperience({payload:experience}){
    try{
        const response = yield call(addExperienceAPI,{...experience})
        const experienceItem = response.data
        yield put(experiencesApiResponseSuccess(ExperiencesActionTypes.ADD_EXPERIENCE,experienceItem))
    } catch(error){
        yield put(experiencesApiResponseError(ExperiencesActionTypes.ADD_EXPERIENCE,error))
    }
}

function* updateExperience({payload:experience}){
    try{
        const response = yield call(updateExperienceAPI,{...experience})
        const experienceItem = response.data.data
        yield put(experiencesApiResponseSuccess(ExperiencesActionTypes.UPDATE_EXPERIENCE,experienceItem))
    }catch(error){
        yield put(experiencesApiResponseError(ExperiencesActionTypes.UPDATE_EXPERIENCE,error))
    }
}
function* deleteExperience({payload:{id}}){
    try{
        const response = yield call(deleteExperienceAPI,id)
        const experienceItem = response.data.id
        yield put(experiencesApiResponseSuccess(ExperiencesActionTypes.DELETE_EXPERIENCE,experienceItem))
    }catch(error){
        yield put(experiencesApiResponseError(ExperiencesActionTypes.DELETE_EXPERIENCE,error))
    }
}

/**
 * List contactos
 */
function* listExperiences({payload:params}) {
    try {
        const response = yield call(listExperiencesAPI, { ...params });
        const listaExperiences = response.data.data;
        yield put(experiencesApiResponseSuccess(ExperiencesActionTypes.LIST_EXPERIENCES, listaExperiences));
    } catch (error) {
        yield put(experiencesApiResponseError(ExperiencesActionTypes.LIST_EXPERIENCES, error));
    }
}


export function* watchGetExperience(): any {
    yield takeEvery(ExperiencesActionTypes.GET_EXPERIENCE, getExperience);
}

export function* watchListExperiences(): any {
    yield takeEvery(ExperiencesActionTypes.LIST_EXPERIENCES, listExperiences);
}

export function* watchAddExperience():any{
    yield takeEvery(ExperiencesActionTypes.ADD_EXPERIENCE,addExperience)
}
export function* watchUpdateExperience():any{
    yield takeEvery(ExperiencesActionTypes.UPDATE_EXPERIENCE,updateExperience)
}
export function* watchDeleteExperience():any{
    yield takeEvery(ExperiencesActionTypes.DELETE_EXPERIENCE,deleteExperience)
}


function* experiencesSaga(): any {
    yield all([
        fork(watchGetExperience),
        fork(watchListExperiences),
        fork(watchAddExperience),
        fork(watchUpdateExperience),
        fork(watchDeleteExperience),
    ]);
}

export default experiencesSaga;
